export class DragScroll {
  constructor(selector, options = {}) {
    this.slider =
      typeof selector === "string" ? document.querySelector(selector) : selector;
    if (!this.slider) return;

    // Options
    this.threshold = options.threshold || 5;
    this.activateLinks = options.activateLinks ?? false;
    this.activeClass = options.activeClass || "is-active";

    // State
    this.isDown = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.isDragging = false;

    // Internal refs
    this.links = Array.from(this.slider.querySelectorAll("a[href^='#']"));
    this.sections = this.links
      .map((a) => document.querySelector(a.getAttribute("href")))
      .filter(Boolean);

    this.init();
  }

  // =========================
  // Init
  // =========================
  init() {
    this.bindEvents();
    if (this.activateLinks) {
      this.observeSections();
    }
  }

  // =========================
  // Event Bindings
  // =========================
  bindEvents() {
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onLinkClick = this.onLinkClick.bind(this);

    this.slider.addEventListener("mousedown", this.onMouseDown);
    this.slider.addEventListener("mouseleave", this.onMouseLeave);
    this.slider.addEventListener("mouseup", this.onMouseUp);
    this.slider.addEventListener("mousemove", this.onMouseMove);

    this.links.forEach((a) => {
      a.setAttribute("draggable", "false");
      a.addEventListener("click", this.onLinkClick);
    });
  }

  // =========================
  // Drag Behavior
  // =========================
  onMouseDown(e) {
    this.isDown = true;
    this.isDragging = false;
    this.startX = e.pageX - this.slider.offsetLeft;
    this.scrollLeft = this.slider.scrollLeft;
    this.slider.classList.add("is-dragging");
  }

  onMouseLeave() {
    this.isDown = false;
    this.slider.classList.remove("is-dragging");
  }

  onMouseUp() {
    this.isDown = false;
    this.slider.classList.remove("is-dragging");
  }

  onMouseMove(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.slider.offsetLeft;
    const walk = x - this.startX;

    if (Math.abs(walk) > this.threshold) {
      this.isDragging = true;
    }

    this.slider.scrollLeft = this.scrollLeft - walk;
  }

  // =========================
  // Link Click
  // =========================
  onLinkClick(e) {
    const link = e.currentTarget;
    if (this.isDragging) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    // Active handling
    if (this.activateLinks) {
    //   this.setActiveLink(link);
      this.scrollActiveLinkIntoView(link);
    }
  }

  // =========================
  // Active link control
  // =========================
//   setActiveLink(link) {
//     this.links.forEach((a) => a.classList.remove(this.activeClass));
//     link.classList.add(this.activeClass);
//   }

  scrollActiveLinkIntoView(link) {
    const linkRect = link.getBoundingClientRect();
    const sliderRect = this.slider.getBoundingClientRect();
    const offset = linkRect.left - sliderRect.left;
    this.slider.scrollBy({
      left: offset,
      behavior: "smooth",
    });
  }

  // =========================
  // Observe sections (scroll tracking)
  // =========================
  observeSections() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = `#${entry.target.id}`;
          const link = this.links.find((a) => a.getAttribute("href") === id);
          if (entry.isIntersecting && link) {
            // this.setActiveLink(link);
            this.scrollActiveLinkIntoView(link);
          }
        });
      },
      {
        rootMargin: "-30% 0px -60% 0px",
        threshold: 0.1,
      }
    );

    this.sections.forEach((section) => observer.observe(section));
  }

  // =========================
  // Cleanup
  // =========================
  destroy() {
    this.slider.removeEventListener("mousedown", this.onMouseDown);
    this.slider.removeEventListener("mouseleave", this.onMouseLeave);
    this.slider.removeEventListener("mouseup", this.onMouseUp);
    this.slider.removeEventListener("mousemove", this.onMouseMove);
    this.links.forEach((a) =>
      a.removeEventListener("click", this.onLinkClick)
    );
  }
}
